import React from "react";
import { Link } from "react-router-dom";
import { AiFillPhone, AiFillFacebook } from "react-icons/ai";
import { BsEnvelopeFill } from "react-icons/bs";
import { BsInstagram, BsFillTelephoneFill } from "react-icons/bs";
import {BiLogoGmail} from "react-icons/bi"
import { FaFacebook, FaXTwitter, FaWhatsapp } from "react-icons/fa6";

const Footer = () => {
  return (
    <>
      <footer className="pt-10 pb-4 w-screen text-black bg-black bg-opacity-[0.05]">
        <div className="w-full h-full flex flex-col gap-10 justify-center items-center">
          <div className="flex flex-col space-y-5">
            <div className="flex space-x-10 items-center text-opacity-80">
              <Link
                to="https://www.instagram.com/revpointsolutions/"
                className="text-2xl"
              >
                <BsInstagram />
              </Link>
              <Link
                to="mailto:revpointsolutions@gmail.com"
                className="text-3xl"
              >
                <BiLogoGmail />
              </Link>
              <Link to="https://twitter.com/revpoints" className="text-2xl">
                <FaXTwitter />
              </Link>
              <Link
                to="https://www.facebook.com/revpointsolutions/"
                className="text-2xl"
              >
                <FaFacebook />
              </Link>
              <Link
                to="https://wa.me/+2348084344424"
                className="text-2xl"
              >
                <FaWhatsapp />
              </Link>
              {/* <Link to="tel:07066541117" className="text-2xl">
                <BsFillTelephoneFill />
              </Link> */}
            </div>
          </div>
          <div className="flex justify-center">
            <p className="opacity-75 text-lg lg:text-xl">
              &copy; 2023, Powered By <Link to="">Revbix</Link>
            </p>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
